import { LoadArticlesPayload } from '@core/models/article.models';

export const DEFAULT_ARTICLES_SEARCH_PARAMS: LoadArticlesPayload = {
  page: 1,
  limit: 9,
  query: '',
  categories: [],
};
